import React, { act, useEffect } from 'react'
import withModal from '../../utils/hoc/withModal'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-stores/store'
import { FREE_SUBSCRIPTION_PLAN_ID } from '../../constants/constants'
import { analyticsLog } from '../../lib/analytics'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
const OutOfCredits: React.FC<{ onClose: () => void, isActive: boolean }> = ({ onClose, isActive }) => {

    const activePlan = useSelector((state: RootState) => state.influencer.active_plan);

    useEffect(() => {
        if (isActive && activePlan) {
            analyticsLog('credits_low', {
                plan: activePlan.plan?.name,
                source: 'campaign_apply'
            })
        }
    }, [isActive, activePlan])

    return (
        <React.Fragment>
            <div className="card-body d-flex flex-column p-4">
                <span className='fs-16 text-dark fw-400'>
                    You've hit your current limit. Unlock more credits to continue collaborating.
                </span>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-3 mb-4 pb-3 gap-2 px-4">
                <Link to={{ pathname: activePlan?.plan?.id === FREE_SUBSCRIPTION_PLAN_ID ? "/subscription-plans" : "/subscription" }} className="btn btn-primary flex-grow-1">SUBSCRIBE</Link>
            </div>
        </React.Fragment>
    )
}

export default withSlideUpModal(OutOfCredits, "You ran out of credits!", true)
